import localFont from '@next/font/local'

export const proximaFont = localFont({
  variable: '--font-proxima',
  display: 'swap',
  src: [
    {
      path: './proxima/ProximaNova-Light.otf',
      weight: '300',
      style: 'normal',
    },
    {
      path: './proxima/ProximaNova-LightItalic.otf',
      weight: '300',
      style: 'italic',
    },
    {
      path: './proxima/ProximaNova-Regular.otf',
      weight: '400',
      style: 'normal',
    },
    {
      path: './proxima/ProximaNova-RegularItalic.otf',
      weight: '400',
      style: 'italic',
    },
    {
      path: './proxima/ProximaNova-Semibold.otf',
      weight: '600',
      style: 'normal',
    },
    {
      path: './proxima/ProximaNova-Bold.otf',
      weight: '700',
      style: 'normal',
    },
    {
      path: './proxima/ProximaNova-BoldIt.otf',
      weight: '700',
      style: 'italic',
    },
    {
      path: './proxima/ProximaNova-Extrabold.otf',
      weight: '800',
      style: 'normal',
    },
    {
      path: './proxima/ProximaNova-Black.otf',
      weight: '900',
      style: 'normal',
    },
  ],
})
